// Application types
const REWARDS = {
  LOADING_INFRACTIONS: "LOADING_INFRACTIONS",
  UPDATING: "UPDATING",
  SEARCHING: "SEARCHING",
  // APPROVING_REWARD: "APPROVING_REWARD",
  FILTERING_INFRACTIONS: "FILTERING_INFRACTIONS",
  // DELETING_FOOD: "DELETING_FOOD",
  // DOWNLOADING: "DOWNLOADING",
  STORE_INFRACTION: "STORE_INFRACTION",
  ALL_INFRACTIONS: "ALL_INFRACTIONS",
  SINGLE_INFRACTION: "SINGLE_INFRACTION",
  // GET_MY_REWARD: "GET_MY_REWARD",
  SEARCH_INFRACTIONS: "SEARCH_INFRACTIONS",
  FILTER_INFRACTIONS: "FILTER_INFRACTIONS",
  UPDATE_INFRACTION: "UPDATE_INFRACTION",
  // CLAIM_REWARD: "CLAIM_REWARD",
  // DELETE_FOOD: "DELETE_FOOD",
  // APPROVE_REWARD_MANAGEMENT: "APPROVE_REWARD_MANAGEMENT",
  // UNAPPROVE_REWARD_MANAGEMENT: "UNAPPROVE_REWARD_MANAGEMENT",
  // ALL_REWARDS_NO_PAGINATION: "ALL_REWARDS_NO_PAGINATION",
};

export default REWARDS;
